var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeafIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10027 9.08047C1.48183 11.6993 0.00752535 15.2489 2.87288e-05 18.9522C-0.00746789 22.6555 1.45245 26.211 4.06027 28.8405C7.00027 22.0405 12.2403 16.3605 18.7803 12.9805C13.1354 17.7568 9.32491 24.3456 8.00027 31.6205C13.2003 34.0805 19.6003 33.1805 23.9003 28.8805C30.8603 21.9205 32.0003 0.980469 32.0003 0.980469C32.0003 0.980469 11.0603 2.12047 4.10027 9.08047Z",
    fill: "#ABE138"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafIcon);
export default __webpack_public_path__ + "static/media/leaf-icon.f376a4b74de3e828177902b13dd80124.svg";
export { ForwardRef as ReactComponent };